import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DropdownTable from '../../OrderEntry/ui/DropdownTable';
import debounce from 'lodash.debounce';
import produce from 'immer';
import axios from 'axios';
import qs from 'qs';
import { Property, SelectedCity } from './types';
import SelectedCityBar from './SelectedCityBar';
import { XIcon } from '../../../components/icons';
import { useAddProperty } from './AddPropertyContext';

interface Props {
    property: Property;
    changePropertyInfo: (label: keyof Partial<Property>, value: any, index: number) => void;
    index: number;
    setPropertyInfo: (p: any, index: number) => void;
  }
  const Municipality = (props: Props) => {
    const { properties, changePropertyInfo, propertyErrors, validateProperty } = useAddProperty();
    const [isDropdown, setIsDropdown] = useState(false);
    const [cityOptions, setCityOptions] = useState<any[]>([]);
    const [cityLoaderStatus, setCityLoaderStatus] = useState(false);
    const [selectedItem, setSelectedItem] = useState(false);
    const baseSelectedCity: SelectedCity = {
      county: '',
      municipality: '',
      municipalityId: null,
      municipalityType: '',
      stateCode: '',
      stateName: '',
      subMunicipality: '',
      subMunicipalityId: null,
      subMunicipalityType: '',
      swisCode: '',
      rpadSwisCode: '',
      countyId: null,
      id: null,
      municipalityTypeId: null,
      subMunicipalityTypeId: null,
      hamletId: null,
      hamletName: '',
    };
    const handleSelectedCity = (item: SelectedCity) => {
      const property: Property = {
        address: properties[props.index].address,
        block: properties[props.index].block,
        countyOnly: false,
        district: null,
        includeMunicipalSearches: true,
        isDuplicate: false,
        isValidated: false,
        lot: properties[props.index].lot,
        municipalityId: item.municipalityId,
        subMunicipalityId: item.subMunicipalityId,
        owners: properties[props.index].owners,
        printKey: properties[props.index].printKey,
        rpadPropertyId: properties[props.index].rpadPropertyId,
        section: properties[props.index].section,
        selectedCity: item,
        zip: properties[props.index].zip,
        addressLine2: properties[props.index].addressLine2,
        validationNote: '',
        validationFiles: [],
        selectedCounty: null,
        hamletId: item.hamletId,
      };
      props.setPropertyInfo(property, props.index);
      setIsDropdown(false);
      setSelectedItem(true)
    };
    const getCityOptions = useCallback(
      debounce(async value => {
        const tempProperty = { ...props.property };
        if (value === '') {
          const newProperty = produce(props.property, draft => {
            // draft.selectedCity = {
            //   county: '',
            //   municipality: '',
            //   municipalityId: null,
            //   municipalityType: null,
            //   stateCode: '',
            //   stateName: '',
            //   subMunicipality: '',
            //   subMunicipalityId: null,
            //   subMunicipalityType: '',
            //   swisCode: '',
            // };
            // draft.cityOptions = [];
          });
          // props.setProperty(newProperty);
          return;
        }
        setCityLoaderStatus(true);
        const { data } = await axios.get('/api/clientproperty/GetCityOptions', {
          params: { searchValue: (value || '').trim() },
          paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          },
        });
  
        // setProperty(tempProperty);
        setCityOptions(data.filter((d, i) => i < 100));
        setIsDropdown(data.length ? true : false);
        setCityLoaderStatus(false);
      }, 600),
      []
    );
    const deleteMuni = () => {
      props.changePropertyInfo('selectedCity', baseSelectedCity, props.index);
    };
    useEffect(() => {
      window.addEventListener('click', () => {
        setIsDropdown(false);
      });
      return () => {
        window.removeEventListener('click', () => {
          setIsDropdown(false);
        });
      };
    }, []);
    return (
      <>
        <div>
          <div style={{ paddingBottom: 8 }}>Municipality</div>
          <div style={{ position: 'relative', width: 696 }}>
            {(props.property?.selectedCity?.municipalityId || false) &&
            props.property?.selectedCity?.municipalityId ? (
              <SelectedCityBar city={props.property?.selectedCity} icon={<XIcon onClick={deleteMuni} />} />
            ) : (
              <div>
                <DropdownTable
                  name="property.selectedCity.subMunicipalityId"
                  label=""
                  width="696px"
                  isDropdown={isDropdown}
                  itemList={cityOptions}
                  onTextChange={e => {
                    getCityOptions(e.target.value);
                    e.stopPropagation();
                  }}
                  onClick={() => {}}
                  onItemClick={e => {
                    handleSelectedCity(e);
                  }}
                  onBlur={e => {
                    if (!selectedItem) {
                      props.changePropertyInfo('undeterminedLocality', e.target.value, props.index);
                    }
                  }}
                  loadingStatus={cityLoaderStatus}
                  styles={{ backgroundColor: '#f7f7f9', svg: { display: 'none' } }}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  };
  
  export default Municipality;
